export var ShareTypes;
(function (ShareTypes) {
    ShareTypes["FACEBOOK"] = "Facebook";
    ShareTypes["WHATSAPP"] = "Whatsapp";
    ShareTypes["EMAIL"] = "Email";
    ShareTypes["COPY"] = "Copy";
    ShareTypes["NATIVE"] = "native";
})(ShareTypes || (ShareTypes = {}));
//# sourceMappingURL=CsShareModal.js.map